import { Component, inject, OnInit } from '@angular/core';
import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { AuthService } from 'src/app/core/services/auth';
import { CustomValidators } from 'src/app/core/validators/CustomValidators';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss'],
})
export class NewPasswordComponent extends BaseComponent implements OnInit {
  authService = inject(AuthService);

  formGroup = this.buildForm();

  token = this.getRouteQueryParam('token');
  idUsuario = this.getRouteQueryParam('idUsuario');

  ngOnInit(): void {
    if (!this.idUsuario || !this.token) {
      this.showInvalidParametersNotification();
      this.redirectToLoginPage();
    }
  }

  onSubmit(): void {
    if (this.formGroup.invalid) {
      this.notification.info('Por favor, preencha os campos corretamente');
      return;
    }

    this.recoveryPass();
  }

  private buildForm() {
    return this.fb.nonNullable.group({
      senha: ['', [Validators.required, CustomValidators.password]],
      confirmeSenha: [
        '',
        [Validators.required, this.confirmarSenhaValidator()],
      ],
    });
  }

  private confirmarSenhaValidator(): ValidatorFn {
    return (confirmeSenha: AbstractControl) => {
      const confirmPasswordValue = confirmeSenha.value;
      const passwordValue = this.formGroup?.controls.senha?.value;

      if (!passwordValue) {
        return null;
      }

      if (confirmPasswordValue === passwordValue) {
        return null;
      }

      return { differentPass: true };
    };
  }

  private showInvalidParametersNotification(): void {
    const msg = 'Parâmetros inválidos. Por favor, tente novamente.';
    this.notification.info(msg);
  }

  private redirectToLoginPage(): void {
    this.router.navigate(['autenticacao', 'entrar']);
  }

  private recoveryPass(): void {
    const formValue = this.formGroup.getRawValue();

    const loaderRef = this.loader.open('Alterando senha...');
    this.authService
      .recoveryPass({
        idUsuario: this.idUsuario,
        token: this.token,
        senha: formValue.senha,
        confirmeSenha: formValue.confirmeSenha,
      })
      .subscribe(() => {
        this.notification.success('Senha alterada com sucesso!');
        this.redirectToLoginPage();
      })
      .add(() => loaderRef.close());
  }
}
